import { createAsyncThunk } from '@reduxjs/toolkit';
import { securedAxiosInstance } from '../../../api/axios';

export const getVaults = createAsyncThunk(
  'vaults/getVaults',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/vaults`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const saveLog = createAsyncThunk(
  'vaults/saveLog',
  async (
    { refId, logDetail, userId, type, isUpdate },
    { getState, rejectWithValue }
  ) => {
    try {
      let response;
      const data = {
        ref_id: refId,
        detail: logDetail,
        deleted: 0,
        user_id: userId,
        relation_type: type,
      };
      if (isUpdate.state) {
        response = await securedAxiosInstance.put(
          `/vaults/${isUpdate.vault.id}`,
          data
        );
      } else {
        response = await securedAxiosInstance.post(`/vaults`, data);
      }
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteLog = createAsyncThunk(
  'vaults/deleteLog',
  async ({ selectedVaults }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.post(`/vaults/destroy_bulk`, {
        resources: { resource_id: selectedVaults },
      });
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
